import { NavLink } from "react-router-dom"
import { useBreakpoints } from "../../hooks/useBreakpoints"
import { useEffect, useRef, useState } from "react"
import { isInButtonOrLink } from "./Menu"
import { FaChevronRight } from "react-icons/fa"

export function Sidebar({ children, value, onChange, ...props }) {
    const { isMobile } = useBreakpoints()

    useEffect(() => {
        onChange(!isMobile)
    }, [isMobile])

    const insideClick = e => {
        if (isInButtonOrLink(e.target) && isMobile) onChange(false)
    }

    return <>
        {isMobile && value && <div onClick={() => onChange(false)} className="fixed inset-0 z-50 bg-black bg-opacity-40"></div>}
        <div {...props} onClick={insideClick} className={`flex flex-col bg-sky-950 text-white fixed left-0 top-0 bottom-0 z-50 md:static w-[280px] shrink-0 overflow-auto ${value ? '' : 'ml-[-280px]'} transition-all softScrollbar ${props.className}`}>
            {children}
        </div>
    </>
}

export function SidebarLink({ children, to, icon, ...props }) {
    return <NavLink {...props} to={to} className={`flex items-center gap-3 p-3 rounded-lg [&.active]:bg-gray-50 [&.active]:text-sky-950 hover:bg-gray-200 hover:text-sky-950 ${props.className}`}>
        {icon}
        {children}
    </NavLink>
}

export function SidebarCollapsible({ children, text, icon, ...props }) {
    const [open, setOpen] = useState(false)
    const [openSize, setOpenSize] = useState()
    const ref = useRef()

    const toggle = () => {
        setOpen(!open)
        setOpenSize(ref.current.scrollHeight + 'px')
    }

    return <div {...props} className="flex flex-col gap-2">
        <div onClick={toggle} className={`cursor-pointer flex items-center gap-3 p-3 rounded-lg [&.active]:bg-gray-50 [&.active]:text-sky-950 hover:bg-gray-200 hover:text-sky-950 ${props.className}`}>
            {icon}
            {text}
            <FaChevronRight className={`ml-auto transition-all ${open ? 'rotate-90' : ''}`} />
        </div>
        <div ref={ref} className="pl-2 flex flex-col gap-2 transition-all overflow-hidden max-h-0" style={{ maxHeight: open ? openSize : 0 }}>
            {children}
        </div>
    </div>
}